import { render, staticRenderFns } from "./reservation-infos.vue?vue&type=template&id=412d889a&scoped=true&"
import script from "./reservation-infos.vue?vue&type=script&lang=js&"
export * from "./reservation-infos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d889a",
  null
  
)

export default component.exports